import { useState, useCallback } from 'react';

const useCounter = initialValue => {
  const [value, setValue] = useState(initialValue);

  const increment = useCallback(() => setValue(prev => prev + 1), []);

  const decrement = useCallback(
    () => setValue(prev => (prev - 1 === 0 ? prev : prev - 1)),
    []
  );

  const setTo = setValue;

  return {
    value,
    increment,
    decrement,
    setTo,
  };
};

export default useCounter;
